'use strict'

import React from 'react';

import Layout from '../Layout.jsx';
import request from 'superagent';

//import templateHandler from '../../app/admin/formatTemplate.js';

class EmailHeader extends React.Component {
  render() {
    return (
      <div style={{display:"table", paddingBottom:5}}>
        {this.props.from!==undefined ? (
          <div style={{display:"table-row"}}>
            <b style={{display:"table-cell"}}>From:</b><span style={{display:"table-cell"}}>{this.props.from}</span>
          </div>
        ) : null}
        <div style={{display:"table-row"}}>
          <b style={{display:"table-cell"}}>To:</b><span style={{display:"table-cell"}}>{this.props.to}</span>
        </div>
        {this.props.cc!==undefined ? (
          <div style={{display:"table-row"}}>
            <b style={{display:"table-cell"}}>CC:</b><span style={{display:"table-cell"}}>{this.props.cc}</span>
          </div>
        ) : null}
        <div style={{display:"table-row"}}>
          <b style={{display:"table-cell"}}>Subject:</b><span style={{display:"table-cell"}}>{this.props.subject}</span>
        </div>
      </div>
    );
  }
}

class Property extends React.Component {
  constructor(props) {
    super(props);
    this.update=this.updateValue.bind(this);
  }

  updateValue(event) {
    event.preventDefault();
    this.props.setParameter(this.props.name,event.target.value);
  }

  render() {
    return (
      <div style={{display:"table-row"}}>
        <b style={{display:"table-cell"}}>{this.props.label!==undefined ? this.props.label : this.props.name.slice(0,1).toUpperCase()+this.props.name.slice(1)}:</b>
        <input style={{display:"table-cell"}} size="50" onChange={this.update} name={this.props.name} value={this.props.parameters!==undefined ? this.props.parameters[this.props.name] : ""} placeholder={this.props.name}/>
      </div>
    );
  }
}

class TemplateContent extends React.Component {
  inline() {
    return {__html: this.props.body};
  }

  render() {
    return (
      <div dangerouslySetInnerHTML={this.inline()}>
      </div>
    );
  }
}

class ViewTemplate extends React.Component {
  constructor(props) {
    super(props);
    var parameters={};
    if (props.type==="email") {
      parameters.recipient="";
    }
    props.parameters.forEach(key=>{
      parameters[key]=props.parameterValues!==undefined && props.parameterValues[key]!==undefined ? props.parameterValues[key] : ""
    });
    this.state={parameters:parameters,content:{}};
    this.setParameter=this.setParameterValue.bind(this);
    this.setParametersAsJSON=this.setJSONParameters.bind(this);
  }

  loadTemplate(id,parameters) {
    request
      .post("/admin/templates/"+id)
      .send(parameters)
      .then(function(response) {
        this.setState({content:response.body});
      }.bind(this))
      .catch(function(error) {
        console.log("Error formatting template: "+JSON.stringify(error));
        console.log("Props: "+JSON.stringify(this.props));
        if (this.props.body!==undefined) {
          console.log("**Set content**: "+this.props.body);
          this.setState({content:{body:this.props.body}});
        }
      }.bind(this));
  }

  componentDidMount() {
    this.loadTemplate(this.props.id,this.state.parameters);
  }

  componentWillReceiveProps(props) {
    this.loadTemplate(props.id,this.state.parameters);
  }

  setParameterValue(key,value) {
    var newParameters=Object.assign({},this.state.parameters,{[key]:value});
    this.setState({parameters:newParameters});
    this.loadTemplate(this.props.id,newParameters);
  }

  setJSONParameters(event) {
    event.preventDefault();
    var parameters={}
    var parameters=event.target.value.length>0 ? JSON.parse(event.target.value) : {};
    this.setState({parameters:parameters});
    this.loadTemplate(this.props.id,parameters);
  }

  render() {
//    var content=templateHandler.formatTemplate(this.props.name,this.state.parameters);
    return (
      <div>
        <b>{this.props.title}</b>
        <div style={{display:"flex"}}>
          <div style={{display:"table"}}>
            {this.props.type==="email" ? <Property parameters={this.state.parameters} setParameter={this.setParameter} label="To" name="recipient"/> : null}
            {this.props.parameters.map(parameter=><Property key={parameter} parameters={this.state.parameters} name={parameter} setParameter={this.setParameter}/>)}
          </div>
          <div style={{paddingLeft:20,flexGrow:2}}>
            <textarea style={{width:"100%", height:"100%"}} onChange={this.setParametersAsJSON} value={JSON.stringify(this.state.parameters)}></textarea>
          </div>

        </div>
        <div style={{backgroundColor: "#ffffff", border:"solid 1px grey", borderRadius:5, padding:15, marginTop:10}}>
          {this.props.type==="email" ? <EmailHeader {...this.state.content}/> : null}
          <TemplateContent {...this.state.content}/>
        </div>
      </div>
    );
  }
}

class TemplateLink extends React.Component {
  constructor(props) {
    super(props);
    this.selectTemplate=this.select.bind(this);
  }

  select(event) {
    event.preventDefault();
    this.props.selectTemplate(this.props);
  }

  render() {
    return (
      <li><a href="#" onClick={this.selectTemplate}>{this.props.title}</a></li>
    );
  }
}

export class TemplateOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state={display:undefined};
    this.selectTemplate=this.select.bind(this);
  }

  select(template) {
    this.setState({display:template});
  }

  render() {
    return (
      <div style={{padding:10}}>
        <h1>Templates</h1>
        <div style={{display:"flex", justifyContent:"flex-start"}}>
          <div>
            <ul>
              {this.props.templates.map(template=><TemplateLink key={template.title} {...template} selectTemplate={this.selectTemplate}/>)}
            </ul>
          </div>
          <div style={{flexGrow:4, paddingLeft:20}}>
            {this.state.display!==undefined ? <ViewTemplate {...this.state.display}/> : null}
          </div>
        </div>
      </div>
    );
  }
}

export default class TemplateOverviewPage extends React.Component {
  render() {
    return (
      <Layout {...this.props}>
        <TemplateOverview {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/admin/TemplateOverview.jsx